import React from 'react';
import { books } from '../data/content';
export function BookCollection() {
  return <section aria-labelledby="collection-heading" className="mt-12" data-id="element-21" data-mp="bnvd7ctldbhz">
      <div className="mx-auto max-w-[640px] text-center" data-id="element-22" data-mp="bm0snzm8flef">
        <p className="text-[12px] font-semibold uppercase tracking-[0.16em] text-gold-500" data-id="element-23" data-mp="gfwn4s3aeq4u">
          The collection
        </p>
        <h3 id="collection-heading" className="mt-2 font-display text-[24px] font-semibold leading-[1.25] tracking-[-0.01em] text-ink-900 md:text-[27px]" data-id="element-24" data-mp="kfnlbgv588je">
          Six books, one at a time
        </h3>
        <p className="mt-2.5 text-[15.5px] leading-[1.6] text-ink-500" data-id="element-25" data-mp="3swiajtj0puf0">
          Each book holds 20 projects and challenges — 120 across the collection.
        </p>
      </div>

      <ol className="mx-auto mt-8 grid max-w-[980px] grid-cols-2 gap-x-4 gap-y-8 md:grid-cols-3 md:gap-x-6 md:gap-y-10" data-id="element-26" data-mp="1nkx9kg69pz4">
        {books.map(book => <li key={book.number} data-id="element-27" data-mp="1d42wttf2g8pz">
            {/* A restrained digital frame: thin border, soft shadow, no page-edge
                or spine treatment that would imply a physical book. */}
            <div className="overflow-hidden rounded-xl border border-cream-300 bg-white p-1 shadow-card" data-id="element-28" data-mp="2vg4sq1uvusmy">
              <img src={book.cover} alt={`Cover of Book ${book.number}, ${book.title}`} className="block w-full rounded-lg" width={800} height={1000} loading="lazy" decoding="async" data-id="element-29" data-mp="2qga11w3a9z0u" />
            </div>

            <p className="mt-3 font-display text-[12px] font-semibold uppercase tracking-[0.14em] text-teal-500" data-id="element-30" data-mp="2coloxst1bajv">
              {book.number}
            </p>
            <p className="mt-1 font-display text-[16px] font-semibold leading-[1.3] text-ink-900" data-id="element-31" data-mp="22sic9t0k3tio">
              {book.title}
            </p>
            <p className="mt-1 text-[13.5px] leading-[1.45] text-ink-500" data-id="element-32" data-mp="1xrum19k5jgpi">{book.focus}</p>
          </li>)}
      </ol>
    </section>;
}